import mongoose from "mongoose";
import { z } from "zod";

const isValidId = (id) => mongoose.Types.ObjectId.isValid(id);

export const AllBlogsSchema = z.object({
  title: z
    .string()
    .min(1, { message: "Title is required." })
    .transform((v) => v.trim()),

  slug: z
    .string()
    .min(1, { message: "Slug is required." })
    .trim()
    .transform(
      (slug) =>
        slug
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, "") // Remove invalid characters
          .replace(/\s+/g, "-") // Replace spaces with hyphens
          .replace(/-+/g, "-") // Replace multiple hyphens with single hyphen
          .replace(/^-|-$/g, "") // Remove leading or trailing hyphens
    )
    .refine((slug) => /^[a-z0-9-]+$/.test(slug), {
      message:
        "Slug must contain only lowercase letters, numbers, and hyphens.",
    }),

  short_description: z
    .string()
    .min(1, { message: "Short description is required." })
    .transform((v) => v.trim()),

  description: z.string().optional(),

  post_date: z.string().optional(),

  featured_image: z
    .string()
    .nullable()
    .refine((value) => value === null || isValidId(value), {
      message: "Featured image must be a valid ObjectId or null.",
    })
    .default(null),

  banner_image: z
    .string()
    .nullable()
    .refine((value) => value === null || isValidId(value), {
      message: "Banner image must be a valid ObjectId or null.",
    })
    .default(null),

  info_image: z
    .string()
    .nullable()
    .refine((value) => value === null || value === "" || isValidId(value), {
      message: "Info image must be a valid ObjectId or null.",
    })
    .default(null),

  order_number: z
    .string()
    .transform((val) => val.trim() || "1")
    .refine((val) => !isNaN(Number(val)) && Number.isInteger(Number(val)), {
      message: "Order number must be a valid number",
    })
    .refine((val) => Number(val) > 0, {
      message: "Order number must be greater than 0",
    }),

  meta_title: z
    .string()
    .default("")
    .transform((v) => v.trim()),

  meta_image: z
    .string()
    .nullable()
    .refine((value) => value === null || value === "" || isValidId(value), {
      message: "Meta Image must be a valid ObjectId or null.",
    })
    .default(null),

  meta_keywords: z
    .string()
    .default("")
    .transform((v) => v.trim()),

  meta_description: z
    .string()
    .default("")
    .transform((v) => v.trim()),
});
